interface Speaker {
  name: string;
  title: string;
  company: string;
  cdtmClass: string;
  image: string;
  linkedin: string;
}

export const SPEAKERS: Speaker[] = [
  {
    name: "Juan Fuentes Fernández",
    title: "Co-Chair, EBAN Sports | Expert Evaluator, European Institute of Innovation & Technology (EIT)",
    company: "",
    cdtmClass: "",
    image: "/images/speaker/juan_fuentes.jpg",
    linkedin: "https://www.linkedin.com/in/juanfuentesfernandez/",
  },
  {
    name: "Iñigo de la Iglesia Santamaría",
    title: "Investment Manager of Mission | Now, with Mission Fund I, we invest in extraordinary people who are building global technological solutions",
    company: "",
    cdtmClass: "",
    image: "/images/speaker/inigo_iglesia.jpg",
    linkedin: "https://www.linkedin.com/in/-inigo/",
  },
  {
    name: "Alejandro Vignoni",
    title: "Entrepeneurship Area Director of IDEAS UPV | Entrepeneurship Ecosystem Director of STARTUPV",
    company: "",
    cdtmClass: "",
    image: "/images/speaker/alejo_vigno.jpg",
    linkedin: "https://www.linkedin.com/in/alejovigno/",
  },
  {
    name: "Ana Moya Correcher",
    title: "AI & Operations Lead at BuhoAI | Operations & IT Lead at Bioemprender",
    company: "",
    cdtmClass: "",
    image: "/images/speaker/ana_moya.jpg",
    linkedin: "https://www.linkedin.com/in/anamoyac/",
  },
  {
    name: "Julián Fernández Calvo",
    title: "Founder Buho AI | Your next coworker is already digital",
    company: "",
    cdtmClass: "",
    image: "/images/speaker/julian_fer.jpg",
    linkedin: "https://www.linkedin.com/in/julianfernandez-iaenmurcia/",
  }
  /*{
    name: "Ferran Pla Cardona",
    title: "Co-Founder CDTM Valencia",
    company: "Antai Ventures",
    cdtmClass: "Class of Spring 2016",
    image: "/images/speaker/ferran_pla.jpeg",
    linkedin: "https://www.linkedin.com/in/fplacardona/?originalSubdomain=es",
  },
  {
    name: "Adrián Villanueva",
    title: "Center Assistant CDTM Valencia",
    company: "CDTM Valencia",
    cdtmClass: "",
    image: "/images/speaker/adrian_villanueva.jpeg",
    linkedin: "https://www.linkedin.com/in/adri%C3%A1n-villanueva-mart%C3%ADnez/",
  }, 
  {
    name: "Tyler Sellars",
    title: "Founder & CEO",
    company: "Cactus AI",
    cdtmClass: "",
    image: "/images/speaker/tyler_sellars.jpeg",
    linkedin: "https://www.linkedin.com/in/tylersellars",
  }, 
  {
    name: "Diana Meri",
    title: "Project Manager",
    company: "Startup Valencia & VDS",
    cdtmClass: "",
    image: "/images/speaker/diana_meri.jpeg",
    linkedin: "https://www.linkedin.com/in/diana-meri",
  },
  {
    name: "Arturo Miquel Veyrat",
    title: "AI Manager",
    company: "NTT Data",
    cdtmClass: "",
    image: "/images/speaker/arturo_miquel.jpeg",
    linkedin: "https://www.linkedin.com/in/arturomiquel/"
  },
  {
    name: "Pia Maria Abdallah",
    title: "Account Executive for Middle East & Africa",
    company: "IBM",
    cdtmClass: "",
    image: "/images/speaker/pia_maria_abdallah.jpeg",
    linkedin: "https://www.linkedin.com/in/piamariaabdallah/"
  },
  {
    name: "Joan Navarro Bellido",
    title: "Data&AI Digital Sales Specialist",
    company: "IBM",
    cdtmClass: "",
    image: "/images/speaker/joan_navarro_bellido.jpeg",
    linkedin: "https://www.linkedin.com/in/joan-navarro-bellido-7790b7202/"
  }*/
];
